import React from 'react';
import ClientsPage from './ClientsPage';

/**
 * Page des Fournisseurs
 * Réutilise ClientsPage avec un filtre sur contact_types = "fournisseur"
 */
const FournisseursPage = () => {
  return <ClientsPage filterType="fournisseur" />;
};

export default FournisseursPage;
